"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _defaultTranslations = require("./defaultTranslations");

var _ = require("../");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledHeaderRow = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: ", ";\n"])), function (p) {
  return p.noPadding ? 0 : "0 0 1rem";
});

var StyledLogoWrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));

var StyledVersion = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: 0.5rem 0;\n  margin-left: 1rem;\n  font-size: 0.875rem;\n  font-family: ", ";\n  color: ", ";\n"])), function (p) {
  return p.theme.fontFamilyDefault;
}, function (props) {
  return props.theme.colorLabel;
});

var StyledRulesButton = _styledComponents.default.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-family: ", ";\n  border-radius: ", ";\n  padding: 0 1.5rem;\n  height: 44px;\n  text-transform: ", ";\n  background: ", ";\n  color: ", ";\n"])), function (p) {
  return p.theme.inputFontSize;
}, function (p) {
  return p.theme.fontFamily;
}, function (p) {
  return p.hasRoundedRulesButton ? "28px" : p.theme.inputBorderRadius;
}, function (p) {
  return p.theme.specialTextTransform;
}, function (props) {
  return props.theme.colorPrimary;
}, function (p) {
  return p.theme.colorPrimaryText;
});

var StyledInfoText = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  border-top: 2px solid ", ";\n  padding-top: 1rem;\n  margin-bottom: 1rem;\n  font-size: 0.625rem;\n  font-weight: ", ";\n  line-height: 1.35;\n  text-align: center;\n  color: ", ";\n"])), function (props) {
  return props.theme.colorBorder;
}, function (p) {
  return p.theme.fontWeightNormal;
}, function (props) {
  return props.theme.colorLabel;
});

var StyledAppIcon = _styledComponents.default.img(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 60px;\n  height: 60px;\n"])));

var Styled18PlusIcon = _styledComponents.default.img(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 20px;\n  height: 20px;\n  margin-left: 4px;\n"])));

var Styled18PlusText = _styledComponents.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  border-top: 2px solid ", ";\n  padding-top: 1rem;\n  margin-bottom: 1rem;\n  font-size: 0.900rem;\n  font-weight: ", ";\n  line-height: 1.35;\n  text-align: center;\n  color: ", ";\n"])), function (props) {
  return props.theme.colorBorder;
}, function (p) {
  return p.theme.fontWeightNormal;
}, function (props) {
  return props.theme.colorLabel;
});

var Low6Footer = function Low6Footer(_ref) {
  var useAssetsCdn = _ref.useAssetsCdn,
      hideGamblingReferences = _ref.hideGamblingReferences,
      hideCtaButton = _ref.hideCtaButton,
      hideCtaText = _ref.hideCtaText,
      getPage = _ref.getPage,
      rulesSlug = _ref.rulesSlug,
      rulesText = _ref.rulesText,
      hasRoundedRulesButton = _ref.hasRoundedRulesButton,
      appVersion = _ref.appVersion,
      appIconUrl = _ref.appIconUrl,
      translations = _ref.translations,
      ctaUrl = _ref.ctaUrl,
      ctaIconUrl = _ref.ctaIconUrl,
      ctaText = _ref.ctaText,
      hasDutchCompliance = _ref.hasDutchCompliance,
      dutchComplianceText = _ref.dutchComplianceText,
      eighteenPlusIcon = _ref.eighteenPlusIcon;

  if (!translations) {
    translations = _defaultTranslations.defaultTranslations;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_.Card, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledHeaderRow, {
      noPadding: hasDutchCompliance ? false : hideCtaButton || hideCtaButton && !hideGamblingReferences,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledLogoWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledAppIcon, {
          src: appIconUrl
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledVersion, {
          children: ["v ", appVersion]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledRulesButton, {
        hasRoundedRulesButton: hasRoundedRulesButton,
        onClick: function onClick() {
          return getPage(rulesSlug, rulesText || translations.rules, useAssetsCdn);
        },
        children: rulesText ? rulesText : translations.rules
      })]
    }), hasDutchCompliance && /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled18PlusText, {
      children: [dutchComplianceText, /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled18PlusIcon, {
        src: eighteenPlusIcon
      })]
    }), !hideGamblingReferences && !ctaUrl && !hideCtaText && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledInfoText, {
      children: "Play the newest fantasy football game everyone is raving about. Pack openings meet fantasy football. Open Packs, build your squad and have a chance to play for \xA3300,000 this PL season."
    }), !hideCtaButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Low6Button, {
      ctaUrl: ctaUrl,
      ctaIconUrl: ctaIconUrl,
      ctaText: ctaText
    })]
  });
};

var _default = Low6Footer;
exports.default = _default;